import tokenCookie from "@/modules/tokenCookie";
import apiResponse from "@/modules/apiResponse";

const {hasValidToken, getToken} = tokenCookie();
const {errorResponse} = apiResponse();
import axios from "axios";
import Apis from "@/urls/apis";

const state = {
    trips: {},
};
const getters = {
    getAgentTrips: (state) => state.trips.docs,
    getAgentTotalTrips: (state) => state.trips.totalDocs,
};
const actions = {
    async getAllTripsForAgent({commit}, payload) {
        if (await hasValidToken()) {
            const header = {
                'Authorization': 'Bearer ' + getToken()
            };

            return new Promise((resolve, reject) => {
                axios.get(Apis.AGENT_ALL_TRIPS, {
                    params: payload,
                    headers: header
                })
                    .then(({data, status}) => {
                        if (status === 200) {
                            commit("setAllTripsForAgent", data.trip)
                            resolve(data.trip)
                        }
                    })
                    .catch(error => {
                        reject(errorResponse(error))
                    });
            });
        }
    },
};
const mutations = {
    setAllTripsForAgent: (state, allTrips) => (state.trips = allTrips),
};

export default {
    state,
    getters,
    actions,
    mutations
};